<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검 정보 -->
    <div class="mt-5 mb-6">
      <p class="title my-4"><i class="dot"></i>점검정보</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">담당부서</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <company-selector
            v-else
            v-model="form.inputB_0"
            @select="targetCompany"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검자명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder="날짜선택"
            v-model="form.inputB_3"
          />
        </div>
      </div>
    </div>

    <!--    점검항목-->
    <vs-row class="my-4">
      <vs-col class="flex items-center">
        <h5><i class="dot"></i>안전보건 관계법령상 의무이행 점검표</h5>
        <div class="flex items-center cursor-pointer" @click="openPopup">
          <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
          <span style="color: #7e72f2"> 이행사항 점검 시 작성요령 </span>
        </div>
      </vs-col>
    </vs-row>
    <table-inspect-division-ep
      class="mt-2"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="false"
      title="안전보건 체크리스트"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup id="popAlert" title="이행사항 점검 시 작성요령" :active.sync="showPopup">
      <table id="PopupTable" style="margin-bottom: 20px; max-width: 800px;">
        <tr>
          <th>증빙자료 첨부</th>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold"> “현업업무” 란 ?<br/>공공행정에서 현업업무에 해당하는 업무내용</b>
            <ul>
              <li class="mb-1">1. 청사 등 시설물의 경비, 유지관리 업무 및 설비ㆍ장비 등의 유지관리 업무</li>
              <li class="mb-1">2. 도로의 유지ㆍ보수 등의 업무</li>
              <li class="mb-1">3. 도로ㆍ가로 등의 청소, 쓰레기ㆍ폐기물의 수거ㆍ처리 등 환경미화 업무</li>
              <li class="mb-1">4. 공원ㆍ녹지 등의 유지관리 업무</li>
              <li class="mb-1">5. 산림조사 및 산림보호 업무</li>
              <li class="mb-1">6. 조리 실무 및 급식실 운영 등 조리시설 관련 업무</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3 font-bold">직영작업장 별 각각 점검표 작성</td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold"> 점검결과 판단기준(연번 1~26번)</b>
            <ul>
              <li class="mb-1">1. 실시 :  점검항목을 100% 이행한 경우 (점검시점 기준)</li>
              <li class="mb-1">2. 미실시 :  점검항목을 이행 중이거나 이행하지 않은 경우</li>
              <li class="mb-1">3. 해당없음 :  점검항목과 무관한 경우</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">작성요령</b>
            <ul class="tab-ul">
              <li class="mb-1">
                <p>· 연번 1 :<span>위험성평가 실시 및 위험성 감소대책 시행</span></p>
                <p>
                  - 사업장 내 게시 및 위험성평가 결과물 작성ㆍ내부결재 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 전 작업장</span><br />
                  <span style="color: #ff0000;">* 위험성평가 결과(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 2 :<span>부서(동)별 산재예방계획 수립</span></p>
                <p>
                  - 부서별 안전보건계획 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 전 부서</span><br />
                  <span style="color: #ff0000;">* 산재예방계획(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 3 :<span>안전·보건 관리규정 게시</span></p>
                <p>
                  - 작업장 내 게시 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 전 작업장</span><br />
                  <span style="color: #ff0000;">* 게시사진 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 4, 5 :<span>물질안전보건자료 보유 현황 목록화 및 게시</span></p>
                <p>
                  - 물질안전보건자료 보유현황 목록화 및 작업장 내 게시 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 해당 작업장</span><br />
                  <span style="color: #ff0000;">* 보유 현황 목록화 및 게시사진 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 6 :<span>물질안전보건자료 교육</span></p>
                <p>
                  - 안전보건교육일지 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : MSDS 취급 부서</span><br />
                  <span style="color: #ff0000;">* 교육일지(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 7 :<span>일반건강진단 실시</span></p>
                <p>
                  - 일반건강진단 실시여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 전부서</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 8 :<span>특수건강진단 실시</span></p>
                <p>
                  - 특수건강진단 실시 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 해당 부서(공원녹지과 공원여과팀 그 외 부서는 ‘해당 없음’ 제출)</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 9, 10 :<span>보호구 지급 및 착용점검, 관리대장 작성여부</span></p>
                <p>
                  - “보호구 지급대장” 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 해당 작업장</span><br />
                  <span style="color: #ff0000;">* 지급대장 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 11 :<span>작업환경측정 실시</span></p>
                <p>
                  - “작업환경측정” 실시 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 작업환경측정 실시 부서 (공원녹지과 ‘실시’로 제출 그 외 부서는 ‘해당 없음’ 제출)</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 12 :<span>작업환경측정 결과 종사자에 공지</span></p>
                <p>
                  - 종사자에게 “작업환경측정” 결과 공지여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 작업환경측정 실시 부서 (공원녹지과 ‘실시’로 제출 그 외 부서는 ‘해당 없음’ 제출)</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 13 :<span>작업환경 개선조치</span></p>
                <p>
                  - 종사자에게 “작업환경측정” 결과 개선여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 작업환경측정 실시 부서 (공원녹지과 ‘실시’로 제출 그 외 부서는 ‘해당 없음’ 제출)</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 14, 15 :<span>근골격계 유해요인 조사 결과 개선 조치</span></p>
                <p>
                  - “근골격계 유해요인 조사 결과 개선 조치” 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 근골격계 유해요인 조사 결과 대상부서(공원녹지과, 도시계획과, 문화관광과, 불광동, 자원순환과, 증산동, 치수과, 행정지원과 ‘실시’로 제출 그 외에 부서는 ‘해당 없음’ 제출)</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 16, 17 :<span>밀폐공간 작업 프로그램 수립 및 실시</span></p>
                <p>
                  - “밀폐공간 프로그램 모니터링 보고서” 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 밀폐공간 작업 대상 부서</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 18 :<span>유해·위험요인 개선 등 안전보건 예산 편성 및 집행</span></p>
                <div>
                  - 산업안전보건을 위한 시설비, 안전 및 보건관리 장비 구입 비용, 안전장구류(개인 보호구 구입 등)<br />
                  &nbsp;&nbsp;시설/기계 점검/ 보수 비용, 교육 훈련 비용/재해예방을 위한 인력 비용, 기타(산업 안전 관련 예산) 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 전 부서</span><br />

<!--                  예시-->
                  <span><b style="font-size: 16px;">예시)</b></span><br />
                  <table class="mt-1" style="border-collapse: collapse;">
                    <tbody>
                    <tr>
                      <th style="padding: 8px 22px;"><div>예산내용</div></th>
                      <th style="padding: 8px 22px;"><div>예산액(천원)</div></th>
                      <th style="padding: 8px 22px;"><div>집행액(천원)</div></th>
                      <th style="padding: 8px 22px;"><div>잔액(천원)</div></th>
                      <th style="padding: 8px 22px;"><div>비고</div></th>
                    </tr>
                    <tr>
                      <td style="padding: 8px 22px; text-align: center;"><span>합 계</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">4,000</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">3,800</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">200</span></td>
                    </tr>
                    <tr>
                      <td style="padding: 8px 22px; text-align: center;"><span>안전보호구 구입</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">1,000</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">900</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">100</span></td>
                    </tr>
                    <tr>
                      <td style="padding: 8px 22px; text-align: center;"><span>시설(장비) 유지보수</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">500</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">500</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">0</span></td>
                    </tr>
                    <tr>
                      <td style="padding: 8px 22px; text-align: center;"><span>안전보호구 구입</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">1,000</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">1,000</span></td>
                      <td style="padding: 8px 22px; text-align: center;"><span style="color: #0029ff;">0</span></td>
                    </tr>
                    </tbody>
                  </table>
                  <span class="mt-1" style="color: #ff0000;">* 안전보건 예산 디지털 안전보건 관리 시스템에 업로드</span>
                </div>
              </li>
              <li class="mb-1">
                <p>· 연번 19 :<span>작업계획서 작성 및 서류보관</span></p>
                <p>
                  - 작업계획서 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 위험 장비 보유 사업장 및 중량물 취급 작업장(주민센터 및 화물자동차 이용하는 부서)</span><br />
                  <span style="color: #ff0000;">* 작업계획서(결재문서)디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 20 :<span>유해·위험기계ㆍ기구 관리 안전검사 실시</span></p>
                <div>
                  ▷ 위험기계 ·기구의 위험장소 또는 부위에 근로자가 통상적인 방법으로 접근하지 못하도록 하는 제한조치를 말하며, 방호망, 방책, 덮개 또는 각종 방호장치 등을 설치하는 것을 말함<br />
                  <span style="color: #0029ff;">* 작성대상 : 위험기계ㆍ기구ㆍ설비 및 방호장치 보유 및 설치 작업장(예시)</span><br />

                  <!--                  예시-->
                  <span><b style="font-size: 16px;">예시)</b></span>
                  <table-custom
                    :board="board"
                    :controls="false"
                    :tableData="[
                      { id: 'input1', title: '연번', type: 'no', width: '80px' },
                      { id: 'input2', title: '대상기계', type: 'text', },
                      { id: 'input3', title: '방호장치', type: 'text', },
                      ]"
                    v-model="exData"
                    style="padding-top: 0!important;"
                  />
                  - 예초기, 기계톱, 지게차, 컨베이어, 파쇄기, 공기압축기, 금속절단기, 크레인,연삭기(그라인더), 원심기, 프레스, 고정형 목재가공용 기계(둥근톱, 띠톱 등)<br />
                  <span style="color: #ff0000;">* 대장 및 점검일지 디지털 안전보건 관리 시스템에 업로드</span><br />
                  ▷ 안전검사 실시 서류로 확인
                  <table class="mt-4 mb-2 w-full" style="border-collapse: collapse;">
                    <tbody>
                    <tr>
                      <th style="padding: 8px 22px;"><div>안전검사 대상 기계</div></th>
                    </tr>
                    <tr>
                      <td style="padding: 8px 22px; text-align: center;"><span>1. 프레스 2. 전단기 3. 크레인(정격 하중이 2톤 미만인 것은 제외) 4. 리프트 5. 압력용기 6. 곤돌라 7. 국소 배기장치(이동식은 제외, 8. 원심기(산업용만 해당)
9. 롤러기(밀폐형 구조는 제외) 10. 사출성형기 11. 고소작업대(화물자동차, 특수자동차에 탑재) 12. 컨베이어 13. 산업용 로봇</span></td>
                    </tr>
                    </tbody>
                  </table>
                  <span style="color: #0029ff;">* 작성대상 : 해당 장비(15종) 보유 작업장(크레인, 컨베이어가 있는 사업장-치수과,공원녹지과 등)</span><br />
                  <span style="color: #ff0000;">* 검사 서류 디지털 안전보건 관리 시스템에 업로드</span>
                </div>
              </li>
              <li class="mb-1">
                <p>· 연번 21 :<span>안전보건 표시 설치 및 부착(넘어짐, 화상, 미끄러짐, 끼임, 중량물취급작업 등)</span></p>
                <p>
                  - 담당자 자체 육안점검으로 확인<br />
                  <span style="color: #0029ff;">* 작성대상 : 전 작업장</span><br />
                  <span style="color: #ff0000;">* 부착사진 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 22 :<span>법령의 요지 게시</span></p>
                <p>
                  - 작업장 내 게시 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 전 작업장</span><br />
                  <span style="color: #ff0000;">* 게시사진 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 23 :<span>신규채용 교육 시 교육</span></p>
                <p>
                  - 신규채용 시 교육일지 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 현업업무 종사자</span><br />
                  <span style="color: #ff0000;">* 교육일지(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>

              <li class="mb-1">
                <p>· 연번 24 :<span>정기안전 보건교육</span></p>
                <p>
                  - 안전보건교육일지 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 현업업무 종사자</span><br />
                  <span style="color: #ff0000;">* 교육일지(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 25 :<span>작업내용 변경시 교육</span></p>
                <p>
                  - 안전보건교육일지 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 현업업무 종사자</span><br />
                  <span style="color: #ff0000;">* 교육일지(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 26 :<span>특별안전 보건교육</span></p>
                <p>
                  - 특별안전교육일지 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 붙임1 참고</span><br />
                  <span style="color: #ff0000;">* 교육일지(결재문서) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import TableInspectDivisionEp from "@/components/TableInspectDivisionEp.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    TableInspectDivisionEp,
    CompanySelector,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inspectList: [],

        stdInfo: {},
        fileList: [],
        photoList: [],
      },
      exData: [{ input1:1, input2:'핸드그라인드(휴대용 연삭기)', input3:'안전커버(날접촉 예방장치)',}]
    };
  },
  methods: {
    targetCompany(value) {
      this.form.inputB_1 = value.com_name;
    },
    updateListCheck(indexTableRow, indexRows, text) {
      this.form.inspectList[indexTableRow].list[indexRows].is_checked = text;
    },
    openPopup() {
      this.showPopup = true;
    },
  },
  computed: {
    inspectTable () {
      return [
        {
          headerInput1Title: '점검 항목',
          headerTitle: '해당부서',
          headerYesTitle: '실시',
          headerNoTitle: '미실시',
          headerNATitle: '해당없음',
          headerNoteTitle: '비고',
          isTypeMode : true,
          isInputMode: false,
          isInput1 : true,
          isInput2 : false,
          isInput3 : false,
          isNote : true,
          inputWidth1: '4fr',
          footer: '※ (중처법=중대재해처벌 등에 관한 법률)',
          list: [
            {
              id: 1,
              type: '1',
              is_checked: '',
              input1: '위험성평가 실시 및 위험성 감소대책 시행(연1회)',
              label: '전 부서(동)',
              title: '유해‧위험요인 확인‧개선 절차마련(반기1회 점검) - 중처법 시행령 제4조 제3호',
            },
            {
              id: 2,
              type: '2',
              is_checked: '',
              input1: '부서(동)별 산재예방계획 수립',
              label: '전 부서(동)',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 3,
              type: '3',
              is_checked: '',
              input1: '안전·보건 관리규정 게시',
              label: '전 부서(동)',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 4,
              type: '4',
              is_checked: '',
              input1: '물질안전 보건자료 화학물질 보유 현황 목록화',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 5,
              type: '5',
              is_checked: '',
              input1: '물질안전보건자료 게시',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 6,
              type: '6',
              is_checked: '',
              input1: '물질안전보건자료 교육',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 7,
              type: '7',
              is_checked: '',
              input1: '일반건강진단 실시',
              label: '전 부서(동)',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },

            {
              id: 8,
              type: '8',
              is_checked: '',
              input1: '특수건강진단 실시',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 9,
              type: '9',
              is_checked: '',
              input1: '보호구 지급 및 착용 점검',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 10,
              type: '10',
              is_checked: '',
              input1: '보호구 관리 대장 작성 여부',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 11,
              type: '11',
              is_checked: '',
              input1: '작업환경측정 실시',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 12,
              type: '12',
              is_checked: '',
              input1: '작업환경측정결과 종사자에게 공지',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 13,
              type: '13',
              is_checked: '',
              input1: '작업환경 개선조치',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 14,
              type: '14',
              is_checked: '',
              input1: '근골격계유해요인조사 실시',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 15,
              type: '15',
              is_checked: '',
              input1: '근골격계 부담작업 유해 요인 조사 결과 개선조치',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 16,
              type: '16',
              is_checked: '',
              input1: '밀폐공간 작업 프로그램 수립',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 17,
              type: '17',
              is_checked: '',
              input1: '밀폐공간 작업 프로그램 실시',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 18,
              type: '18',
              is_checked: '',
              input1: '유해·위험요인개선 등 안전보건 예산 편성 및 집행',
              label: '전 부서(동)',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 19,
              type: '19',
              is_checked: '',
              input1: '작업계획서 작성 및 작업지휘자 지정\n' +
                '(차량계 하역운반기계, 중량물 취급작업 등)',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 20,
              type: '20',
              is_checked: '',
              input1: '유해위험기계·기구 관리 안전검사 실시\n' +
                '해당 있는 부서는 (대상기계기구 보유현황 및 점검일지, 안전검사필증(사진), 검사주기 등',
              label: '해당 부서',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 21,
              type: '21',
              is_checked: '',
              input1: '안전보건 표지설치',
              label: '전 부서(동)',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },
            {
              id: 22,
              type: '22',
              is_checked: '',
              input1: '법령요지 등 게시',
              label: '전 부서(동)',
              title: '안전보건 관계법령상 의무이행 조치(반기1회 점검) - 중처법 시행령 제5조'
            },

            {
              id: 23,
              type: '23',
              is_checked: '',
              input1: '채용시 교육',
              label: '전 부서(동)',
              title: '안전보건교육 실시 및 이수여부 확인(반기 1회 점검) - 중처법 시행령 제6조'
            },
            {
              id: 24,
              type: '24',
              is_checked: '',
              input1: '정기교육(분기6시간)',
              label: '전 부서(동)',
              title: '안전보건교육 실시 및 이수여부 확인(반기 1회 점검) - 중처법 시행령 제6조'
            },
            {
              id: 25,
              type: '25',
              is_checked: '',
              input1: '작업내용 변경시 교육',
              label: '전 부서(동)',
              title: '안전보건교육 실시 및 이수여부 확인(반기 1회 점검) - 중처법 시행령 제6조'
            },
            {
              id: 26,
              type: '26',
              is_checked: '',
              input1: '특별안전보건교육',
              label: '전 부서(동)',
              title: '안전보건교육 실시 및 이수여부 확인(반기 1회 점검) - 중처법 시행령 제6조'
            },
          ]
        },
      ]
    },
  }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    //margin-left: 16px;
    //list-style:none;
    &::marker {
      //content: " · ";
      //font-size: 1.2em;
    }
  }
}

</style>
